module.exports = __webpack_public_path__ + "static/media/node.fd723f28.png";